export default __webpack_public_path__ + "static/media/radijatortrend.130d080e.jpg";